import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Footer.module.css';

// Import the logo image
import logo from '../../assets/images/logo.png';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.top}>
          <div className={styles.about}>
            <div className={styles.logoWrapper}>
              <img src={logo} alt="IMDF Logo" className={styles.logoImage} />
              <div className={styles.logoTextWrapper}>
                <h3>Idoma Medical Doctors Foundation</h3>
                <p>Towards a Healthy Idoma Nation</p>
              </div>
            </div>
          </div>
          <div className={styles.links}>
            <div className={styles.column}>
              <h4>Quick Links</h4>
              <ul>
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/leadership">Leadership</Link></li>
                <li><Link to="/membership">Membership</Link></li>
                <li><Link to="/activities">Activities</Link></li>
              </ul>
            </div>
            <div className={styles.column}>
              <h4>Resources</h4>
              <ul>
                <li><Link to="/publications">Publications</Link></li>
                <li><Link to="/constitution">Constitution</Link></li>
                <li><Link to="/contact">Contact</Link></li>
                <li><Link to="/donate">Donate</Link></li>
              </ul>
            </div>
            <div className={styles.column}>
              {/* <h4>Connect</h4>
              <ul className={styles.social}>
                <li><a href="#" target="_blank" rel="noopener noreferrer">Facebook</a></li>
                <li><a href="#" target="_blank" rel="noopener noreferrer">Twitter</a></li>
                <li><a href="#" target="_blank" rel="noopener noreferrer">LinkedIn</a></li>
                <li><a href="#" target="_blank" rel="noopener noreferrer">Instagram</a></li>
              </ul> */}
            </div>
          </div>
        </div>
        <div className={styles.bottom}>
          <p>&copy; {currentYear} Idoma Medical Doctors Foundation. All rights reserved.</p>
          <p>Built with care for the Idoma nation.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;